"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _i18n = require("../../../../../Framework/i18n");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    toolButtonPositioning: _defineProperty({
      width: 40,
      height: 40,
      minWidth: 35,
      minHeight: 35,
      margin: '0px 8px 0 0'
    }, theme.breakpoints.down('xs'), {
      margin: '0px 5px 0 0'
    })
  };
};
var ObjectTools = /*#__PURE__*/function (_React$Component) {
  _inherits(ObjectTools, _React$Component);
  var _super = _createSuper(ObjectTools);
  function ObjectTools() {
    _classCallCheck(this, ObjectTools);
    return _super.apply(this, arguments);
  }
  _createClass(ObjectTools, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        handleObjectButtonClick = _this$props.handleObjectButtonClick,
        flipToBackDisabled = _this$props.flipToBackDisabled,
        flipToFrontDisabled = _this$props.flipToFrontDisabled;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "align_horizontal_center"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.toolButtonPositioning + ' object-btn',
        variant: "outlined",
        value: "alignHorizontalCenter",
        onClick: handleObjectButtonClick
      }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: (0, _i18n.t)('objectTools.alignHorizontalCenter')
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "flip")))), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "align_vertical_center"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.toolButtonPositioning + ' object-btn',
        variant: "outlined",
        value: "alignVerticalCenter",
        onClick: handleObjectButtonClick
      }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: (0, _i18n.t)('objectTools.alignVerticalCenter')
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        style: {
          transform: 'rotate(90deg)'
        }
      }, "flip")))), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "align_move_down"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.toolButtonPositioning + ' object-btn',
        variant: "outlined",
        value: "moveDown",
        onClick: handleObjectButtonClick,
        disabled: flipToBackDisabled
      }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: (0, _i18n.t)('objectTools.moveDown')
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "flip_to_back")))), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "align_move_up"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.toolButtonPositioning + ' object-btn',
        variant: "outlined",
        value: "moveUp",
        onClick: handleObjectButtonClick,
        disabled: flipToFrontDisabled
      }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: (0, _i18n.t)('objectTools.moveUp')
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "flip_to_front")))));
    }
  }]);
  return ObjectTools;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'ObjectTools'
})(ObjectTools));